import React, { forwardRef } from 'react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  helperText?: string;
  options?: SelectOption[];
  placeholder?: string;
}
export const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  label,
  error,
  helperText,
  options = [],
  placeholder,
  className = '',
  id,
  ...props
}, ref) => {
  const selectId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-263">
        {label && <label htmlFor={selectId} className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-264">
            {label}
          </label>}
        <select ref={ref} id={selectId} className={`
          block w-full rounded-lg border transition-colors duration-150
          focus:outline-none focus:ring-2 focus:ring-offset-0
          disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed
          ${error ? 'border-red-300 text-red-900 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500'}
          px-3 py-2.5 text-sm bg-white
          ${className}
        `} {...props} data-id="element-265">
          {placeholder && <option value="" disabled data-id="element-266">
              {placeholder}
            </option>}
          {options.map(option => <option key={option.value} value={option.value} data-id="element-267">
              {option.label}
            </option>)}
        </select>
        {error && <p className="mt-1.5 text-sm text-red-600" data-id="element-268">{error}</p>}
        {helperText && !error && <p className="mt-1.5 text-sm text-gray-500" data-id="element-269">{helperText}</p>}
      </div>;
});
Select.displayName = 'Select';